const SuperAdminHome = () => import('@/modules/SuperAdminHome')

export default [
	{
		component: SuperAdminHome,
		name: 'sa-home',
		path: 'home'
	}
]
